<template>
    <el-dialog
        class="supplier_black_dialog"
        title="供应商拉黑"
        :visible.sync="openBlackDialog"
        top="4%"
        width="600px"
        :before-close="closeDialog">
        <div class="dialog_body">
            <el-row>
                <el-col :span="12">
                    <div>
                        <span class="title">供应商编码&nbsp;&nbsp;</span>
                        <span class="content">{{ row.supplierCode }}</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div>
                        <span class="title">供应商名称&nbsp;&nbsp;</span>
                        <span class="content">{{ row.supplierNameCn }}</span>
                    </div>
                </el-col>
            </el-row>
            <el-form ref="form" :model="form" :rules="rules" label-width="70px" size="mini" style="font-size: 14px;">
                <el-row class="memo">
                    <el-col :span="24">
                        <el-form-item label="拉黑原因" prop="memo">
                            <el-input v-model="form.memo"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="附件上传" prop="fileName" class="upload_item">
                            <el-input v-model="form.fileName" placeholder="点击上传附件"></el-input>
                            <register-upload :uploadDisplayType="uploadDisplayType" class="upload_item_icon" :flag="'fileName'" @uploadSuccess="uploadSuccess"></register-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" :loading="loading" @click="confirmDialog">保 存</el-button>
  </span>
    </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
// import { dictWithUrl } from '../../../../api/dict';
import { saveBlackSupplier, createBlackDraftProcess } from '../../../../api/register/supplierList';
import registerUpload from '../../../../components/upload/Index.vue';
import { FD_TEMPLATE_CODE } from '../../../../constant/constant';

export default {
    name: 'supplier-black-dialog',
    components: { registerUpload },
    props: {
        openBlackDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        row: {
            type: Object,
            default() {
                return {};
            }
        },
        formData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            allowSubmit: false,
            uploadDisplayType: 'icon',
            form: {
                memo: '',
                fileName: '',
                fileUrl: ''
            },
            rules: {
                memo: [
                    { required: true, message: '请输入拉黑原因', trigger: ['blur', 'change'] }
                ]
            },
            loading: false
        };
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode']),
        // 当前用户usercode
        loginName() {
            return this.$store.state.user.userCode;
        }
    },
    methods: {
        handleVerify() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.allowSubmit = true;
                }
            });
        },
        closeDialog() {
            this.$emit('closeDialog', false);
            this.clear();
        },
        async confirmDialog() {
            this.handleVerify();
            if (!this.allowSubmit) {
                return false;
            }
            const { id, supplierCode, supplierNameCn, businessType, businessTypeId } = this.row;
            const formParams = {
                ...this.form,
                supplierCode,
                supplierName: supplierNameCn,
                businessTypeId,
                id: id || null
            };
            this.loading = true;
            const saveBlackRes = await saveBlackSupplier(formParams);

            if (!saveBlackRes) {
                this.loading = false;
                return false;
            }

            const mipFormId = saveBlackRes.data;
            const fdUrl = location.origin + location.pathname + `#/keyData/mipMessage?mipFormId=${mipFormId}&reviewType=black`;
            const mipParams = {
                supplierCode,
                businessType,
                tenantCode: this.currentTenant.tenantCode,
                appCode: this.applicationCode,
                loginName: this.loginName,
                // fdTemplateId: FD_TEMPLATE_ID.BLACK,
                fdTemplateCode: FD_TEMPLATE_CODE.BLACK,
                formParam: {
                    formData: null,
                    subject: `供应商拉黑审批流程-${supplierCode}`,
                    formInstanceId: mipFormId,
                    fdUrl
                }
            };
            this.loading = true;
            const processRes = await createBlackDraftProcess(mipParams);
            this.loading = false;
            if (processRes && processRes.data) {
                this.closeDialog();
                const { fdId, formId } = processRes.data;
                this.$router.push({
                    name: 'mipIframe',
                    query: {
                        processId: fdId,
                        formInstanceId: formId,
                        path: '/keyData'
                    }
                });
            }
        },
        uploadSuccess(data) {
            this.form.fileId = data.data.data.id;
            this.form.fileName = data.data.data.localFileName;
            this.form.fileUrl = data.data.data.downUrl;
        },
        clear() {
            this.contract = '';
            this.form = {
                memo: '',
                fileName: '',
                fileUrl: ''
            };
        }
    },
    watch: {
        formData(val) {
            if (val) {
                this.form = { ...val };
            }
        }
    }
};
</script>

<style lang="less">
    .supplier_black_dialog {
        .dialog_body {
            padding: 20px 50px;
            box-sizing: border-box;
            width: 100%;
            height: 200px;

            .el-form-item__label {
                text-align: left;
            }

            .el-row {
                margin-bottom: 15px;
            }

            .upload_item {
                position: relative;

                .upload_item_icon {
                    position: absolute;
                    top: 2px;
                    left: 0;
                    width: 291.19px;
                    height: 28px;
                    font-size: 16px;
                    color: #33c9cc;
                }

                .upload-demo {
                    width: 100%;
                    height: 28px;
                }

                .el-input {
                    width: 291.19px;
                }

                .el-form-item__label {
                    text-align: right;
                }
            }

            .el-upload {
                width: 100%;
                height: 28px;
                text-align: right;
                box-sizing: border-box;
            }

            .upload_icon {
                padding-right: 6px;
                width: 100%;
                height: 23px;
                box-sizing: border-box;
            }

            .title {
                color: #666;
            }

            .memo {
                margin-bottom: 0;
            }
        }
    }
</style>
